export default [
    {
        name: 'Dashboard',
        icon: 'nc-icon nc-layout-11',
        path: '/portal/dashboard'
    },
    {
        name: 'Users',
        icon: 'fa fa-user',
        path: '/portal/users'
    },
    {
        name: 'Orders',
        icon: 'fa fa-file-text',
        path: '/portal/orders'
    }
]
